import { render, staticRenderFns } from "./templateComs.vue?vue&type=template&id=853c6d3e&"
import script from "./templateComs.vue?vue&type=script&lang=js&"
export * from "./templateComs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports